import { css } from 'styled-components/macro';

export const containerCss = css`
  padding-top: 4rem;
  padding-bottom: 4rem;

  @media (max-width: 962px) {
    padding-bottom: 2rem;
  }
`;

export const landingHeaderCss = css`
  z-index: 3;
  width: 100%;
  height: 100%;
  position: relative;
  background: #def2f0;

  @media (max-width: 1024px) {
    height: 100%;
    padding: 5rem 0;
  }
  @media (max-width: 962px) {
    padding: 3rem 0;
  }
  @media (max-width: 500px) {
    padding: 3rem 0 0 0;
  }
`;

export const landingContentCss = css`
  z-index: 2;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 768px) {
    flex-direction: column-reverse;
    align-items: flex-start;
  }

  h1 {
    margin-top: 0;
    font-size: 48px;
    font-weight: 700;
    line-height: 58px;

    @media (max-width: 500px) {
      font-size: 40px;
    }

    @media (max-width: 350px) {
      font-size: 30px;
      line-height: 40px;
    }
  }

  p {
    font-size: 24px;
    font-weight: 400;
    line-height: 29px;

    @media (max-width: 500px) {
      font-size: 20px;
    }
    @media (max-width: 350px) {
      font-size: 15px;
    }
  }
`;

export const landingHeaderImg = css`
  margin-top: 1rem;

  @media (max-width: 962px) {
    display: none;
  }
`;

export const leftTopOrnamentCss = css`
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
`;

export const gotoLinksCss = css`
  gap: 2rem;
  display: flex;
  margin-top: 2rem;
  flex-direction: row;
  text-transform: uppercase;

  @media (max-width: 500px) {
    flex-direction: column;
  }
`;

export const bottomRightOrnamentCss = css`
  right: 0;
  bottom: 0;
  z-index: 1;
  position: absolute;
`;

export const dotsOrnamentCss = css`
  right: 0;
  z-index: -1;
  position: absolute;
  top: calc(50% - 55px);

  @media (max-width: 962px) {
    top: unset;
    bottom: 0;
  }
`;
